var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content",staticStyle:{"background-color":"#103037","border-radius":"15px","padding":"0px 0px"}},[(!_vm.loaded)?_c('loading'):_vm._e(),(_vm.url.length > 0)?_c('iframe',{staticStyle:{"width":"100%","height":"680px","border-radius":"15px"},attrs:{"src":_vm.url,"frameborder":"0"}}):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bb66ae8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Play.vue
// module id = null
// module chunks = 